import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { pageRoutes } from "../routes/pageRoutes";
import { Formik } from "formik";
import ErrorMessage from "../components/ErrorMessage";
import { signInSchema } from "../utils/schema";
import { pipSetAccessToken } from "../utils/pip";
import { authLogin } from "../redux/action/authAction";
import Loader from "../components/other/Loader";

const Login = () => {
  const navigate = useNavigate();
  const { isToggle, isLoading } = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  const [isEye, setIsEye] = useState(true);
  const initialValue = {
    email: "",
    password: "",
  };

  const handleLogin = async (values) => {
    const callback = (response) => {
      if (response.success) navigate(pageRoutes?.newDashBoard);
    };
    dispatch(authLogin({ payload: values, callback }));
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <section className="ct_login_bg_main">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xxl-5 col-xl-6 col-lg-6 col-md-6 ms-auto">
              {/* <div className="ct_grey_logo">
                <img src="assets/img/grey_logo.png" alt="" />
              </div> */}
              <div className="ct_login_form_bg">
                <div className="ct_logo">
                  <a>
                    {" "}
                    <img src="assets/img/logo.svg" alt="" />
                  </a>
                </div>
                <div className="ct_login_inner_bg">
                  <Formik
                    initialValues={initialValue}
                    validationSchema={signInSchema}
                    onSubmit={(values, actions) => {
                      handleLogin(values);
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      setFieldValue,
                    }) => (
                      <form
                      // onSubmit={() => navigate(pageRoutes?.newDashBoard)}
                      >
                        <h3 className="ct_fs_26 ct_fw_700 ct_mb_32 text-center">
                          Admin Log In
                        </h3>
                        <div className="form-group mb-3">
                          <label for="" className="mb-2 ct_fw_600">
                            Email
                          </label>
                          <input
                            type="email"
                            className="form-control ct_input"
                            id="email"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values?.email}
                            placeholder="Enter email"
                          />
                          <ErrorMessage
                            errors={errors}
                            touched={touched}
                            fieldName="email"
                          />
                        </div>

                        <div className="form-group mb-3">
                          <label for="" className="mb-2 ct_fw_600">
                            Password
                          </label>
                          <div className="position-relative">
                            <input
                              className="form-control ct_input"
                              placeholder="Enter password"
                              type={isEye ? "password" : "text"}
                              id="password"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values?.password}
                            />
                            {/* <i class="fa-regular fa-eye-slash ct_eye_top"></i> */}
                            <i
                              className={`fa-regular ct_eye_show ct_pointer_curser ct_eye_top ${
                                isEye ? "fa-eye-slash" : "fa-eye"
                              }`}
                              onClick={() => setIsEye(!isEye)}
                            ></i>
                          </div>
                          <ErrorMessage
                            errors={errors}
                            touched={touched}
                            fieldName="password"
                          />
                        </div>
                        <div className="ct_forgot_password_link">
                          <a
                            href="javascript:void(0)"
                            onClick={() => navigate(pageRoutes?.forgotPassword)}
                          >
                            Forgot Password?
                          </a>
                        </div>
                        <div className="mt-4">
                          <button
                            onClick={handleSubmit}
                            className="ct_orange_btn w-100"
                          >
                            Log in
                          </button>
                        </div>
                      </form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Login;
